/**
 * Created by sagardesai on 20/06/18.
 */

export const NOTIFICATION_LIST_REQUEST = "NOTIFICATION_LIST_REQUEST";
export const NOTIFICATION_LIST_RECEIVE = "NOTIFICATION_LIST_RECEIVE";
export const NOTIFICATION_LIST_FAILURE = "NOTIFICATION_LIST_FAILURE";
export const NOTIFICATION_LIST_RESET = "NOTIFICATION_LIST_RESET";